<ion-content>

  <div class="container">
    <h2>reprovação</h2>
    <ion-icon (click)="close()" name="close"></ion-icon>

    <scale-change-request-card
      [requestData]="requestData"
      [showFooter]="false"
      style="background-color: rgb(242, 213, 213);"
      [itemColor]="'rgb(247, 230, 230)'"
    />

    <textarea rows="6" placeholder="Motivo da reprovação (opcional)"></textarea>
    <ion-button (click)="confirmOperation()">
      confirmar reprovação
    </ion-button>
  </div>
</ion-content>
